import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import MuiButton from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import pxToRem from "libs/pxToRem";
import Modal from "components/styled/modal/Modal";
import { SolicitudConsumoAnalisisResponse } from "api/types/originacion/services/analisisSolicitudTypes";

const AprobarSolicitud: React.FC<{
  handleAprobar: (tipoCallback: number, estadoTicket: number) => void;
  isLoading: boolean;
  solicitud: SolicitudConsumoAnalisisResponse;
}> = ({ handleAprobar, isLoading, solicitud }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [tipoCallback, setTipoCallback] = useState<number | "">("");
  const [estadoTicket, setEstadoTicket] = useState<number | "">("");
  const canSubmit = !isLoading && tipoCallback !== "" && estadoTicket !== "";

  const handleClose = () => {
    setModalIsOpen(false);
    setTipoCallback("");
    setEstadoTicket("");
  };

  const handleSubmit = () => {
    if (tipoCallback !== "" && estadoTicket !== "") {
      handleAprobar(tipoCallback, estadoTicket);
      handleClose();
    }
  };

  return (
    <>
      <Button onClick={() => setModalIsOpen(!modalIsOpen)}>Aprobar</Button>
      <Modal
        maxWidth="md"
        opened={modalIsOpen}
        onClose={handleClose}
        title="Aprobar solicitud de consumo"
        dialogActions={
          <ModalButton
            disabled={!canSubmit}
            onClick={handleSubmit}
            startIcon={<CheckCircleOutlineIcon />}
          >
            {isLoading && "Aprobando..."}
            {!isLoading && "Aprobar"}
          </ModalButton>
        }
      >
        <ModalContent>
          <IdSection>
            <DescriptionOutlinedIcon
              style={{ color: "hsl(263, 55%, 53%)", fontSize: pxToRem(20) }}
            />
            <IdText>Solicitud #{solicitud.id}</IdText>
          </IdSection>

          <ExceptionSection>
            <SectionSubtitle>
              Seleccione los valores correspondientes para aprobar la solicitud
            </SectionSubtitle>

            <DropdownsContainer>
              <TextField
                select
                label="Callback"
                value={tipoCallback}
                onChange={(e) => setTipoCallback(Number(e.target.value))}
                variant="outlined"
                size="small"
                fullWidth
                SelectProps={{
                  MenuProps: {
                    PaperProps: { sx: { maxWidth: "100%" } },
                  },
                }}
              >
                <MenuItem value={1}>Bot</MenuItem>
                <MenuItem value={2}>Llamado</MenuItem>
                <MenuItem value={3}>Whatsapp</MenuItem>
                <MenuItem value={4}>Excepción</MenuItem>
              </TextField>

              <TextField
                select
                label="Ticket"
                value={estadoTicket}
                onChange={(e) => setEstadoTicket(Number(e.target.value))}
                variant="outlined"
                size="small"
                fullWidth
                SelectProps={{
                  MenuProps: {
                    PaperProps: { sx: { maxWidth: "100%" } },
                  },
                }}
              >
                <MenuItem value={1}>OK</MenuItem>
                <MenuItem value={2}>Pendiente</MenuItem>
                <MenuItem value={3}>Monto Insuficiente</MenuItem>
                <MenuItem value={4}>Otra excepción</MenuItem>
              </TextField>
            </DropdownsContainer>
          </ExceptionSection>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AprobarSolicitud;

const Button = styled(MuiButton)({
  height: pxToRem(28),
  marginLeft: pxToRem(8),
});
Button.defaultProps = {
  variant: "contained",
  color: "secondary",
  size: "small",
};

const ModalButton = styled(MuiButton)({
  minWidth: pxToRem(140),
});
ModalButton.defaultProps = {
  variant: "contained",
  color: "secondary",
  size: "small",
  fullWidth: false,
};

const ModalContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(16),
  padding: pxToRem(16),
});

const IdSection = styled("div")({
  backgroundColor: "#f5f5f5",
  borderLeft: `${pxToRem(4)} solid hsl(190, 63%, 57%)`,
  padding: `${pxToRem(12)} ${pxToRem(16)}`,
  borderRadius: pxToRem(4),
  display: "flex",
  alignItems: "center",
  gap: pxToRem(10),
});

const IdText = styled(Typography)({
  fontSize: pxToRem(15),
  fontWeight: 600,
  color: "#424242",
  margin: 0,
  lineHeight: 1,
  display: "flex",
  alignItems: "center",
});

const ExceptionSection = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(12),
});

const SectionSubtitle = styled(Typography)({
  fontSize: pxToRem(13),
  color: "#757575",
  margin: 0,
  marginTop: pxToRem(-4),
});

const DropdownsContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(16),
  marginTop: pxToRem(4),
});
